const START = new Date('2026-09-04T12:00:00Z'); // Sep 4, 8:00 PM SGT
const END   = new Date('2026-09-07T16:00:00Z'); // Sep 8, 12:00 AM SGT
const postSale = document.getElementById('nomral-content');
const timedContent = document.getElementById('timed-content');
function pad(n) {
  return String(n).padStart(2, '0');
}

function unit(value, label) {
  return `<span class="cd-unit"><span class="cd-value">${value}</span><span class="cd-label">${label}</span></span>`;
}

function sep() {
  return `<span class="cd-sep">:</span>`;
}

function renderCountdown() {
  const now = new Date();
  const el = document.getElementById('countdown');
  let target, prefix;

  if (now < START) {
    target = START;
    prefix = 'Sale starts in: ';
  } else if (now < END) {
    target = END;
    prefix = 'Sale ends in: ';
  } else {
    // el.textContent = 'Sale has ended';
    timedContent.style.display = 'none';
  postSale.style.display = 'block';
    return;
  }

  const totalSec = Math.floor((target - now) / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;

  el.innerHTML =
    `<span class="cd-prefix">${prefix}</span>` +
    unit(days, 'DAYS') + sep() +
    unit(pad(hours), 'HRS') + sep() +
    unit(pad(minutes), 'MINS') + sep() +
    unit(pad(seconds), 'SECS');
}

renderCountdown();
setInterval(renderCountdown, 1000);